/**
 * 高阶组件，返回带公共功能的report组件
 */
import React, { PureComponent } from 'react'
import { connect } from 'react-redux';

export default function(WrappedComponent, {destroy = null} = {}){
  class ReportWraper extends PureComponent {

    constructor(){
      super();
      this.state = {
        query: {}
      }
    }

    // 销毁时删除数据
    componentWillUnmount(){
      if(destroy){
        this.props.$$DASH.destroyNode(destroy)
      }
    }
    
    // 设置查询条件
    setQuery = (query) =>{
      this.setState({
        query: _.merge({}, {...this.state.query, ...query})
      })
    }

    // 设置排序字段和正反序列
    orderSort = (newOrderBy) =>{
      const {orderBy, sortBy} = this.state.query;
      if(newOrderBy != orderBy){
        return this.setQuery({orderBy: newOrderBy, sortBy: 'desc'})
      }
      this.setQuery({sortBy: sortBy == 'desc' ? 'asc' : 'desc'});
    }

    // 获取排序小ICON
    getSortIcon = (field) =>{
      return this.state.query.orderBy != field ? '' : this.state.query.sortBy
    }

    render() {
      /* eslint-disable no-unused-vars */
      const {$$DASH, ...exts} = this.props;
      console.log($$DASH)
      console.log(...exts)
      return (
        <div>
          <WrappedComponent 
            setQuery={this.setQuery} 
            querys={this.state.query}
            orderSort={this.orderSort}
            getSortIcon={this.getSortIcon}
            {...exts}
          />
        </div>
      )
    }
  }

  function mapStateToProps() {
    return {
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      $$DASH: bindActionCreators(dashAction, dispatch)
    };
  }
  
  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(ReportWraper);

}


